export function parseJsonOrNull(json: string): unknown | null {
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function jsonStringifyOrNull(value: unknown): string | null {
  if (value === null || value === undefined) {
    return null;
  }

  try {
    return JSON.stringify(value);
  } catch {
    return null;
  }
}
